export const api_url="https://dashboard.alkhuyol.com";
export const storage_url="https://dashboard.alkhuyol.com/storage"
// export const api_url="https://alkhuyol-dashboard.rewardszone.net";
// export const storage_url="https://alkhuyol-dashboard.rewardszone.net/storage"